import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useOutlet } from 'react-router';
import LandingNavBar from '../landing/NavBar';
import styles from './LegalLayout.module.scss';
function LegalLayout(param) {
    var children = param.children;
    var outlet = useOutlet();
    if (children == null && outlet == null) {
        throw new Error('LegalLayout requires children or an Outlet');
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.legalLayout,
        children: [
            /*#__PURE__*/ _jsx(LandingNavBar, {
                className: styles.navBar
            }),
            children !== null && children !== void 0 ? children : outlet
        ]
    });
}
export default LegalLayout;
